import React, { useState, useEffect } from "react";
import style from "./GoalDetail.module.css";
import { baseurl } from "../Url";

function GoalDetails() {
  const [goals, setGoals] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const userId = localStorage.getItem("USERID");
    const learningId = localStorage.getItem("newLearningId");

    if (!userId || !learningId) {
      setError("User ID and Learning ID are required.");
      setLoading(false);
      return;
    }

    const fetchUserGoals = async () => {
      try {
        const response = await fetch(`${baseurl}/list/usergoals-check`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            user_id: userId,
            learning_id: learningId,
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch user goals.");
        }

        const data = await response.json();

        if (data.status) {
          setGoals(data);
        } else {
          setError(data.message || "No goals found.");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserGoals();
  }, []);

  // Helper to render nested objects and arrays
  const renderNestedArray = (nestedArray) => {
    return nestedArray.map((item, index) => (
      <div key={index}>
        {Object.entries(item).map(([key, value], subIndex) => (
          <div className={style.padded} key={subIndex}>
            <strong>{key} : </strong>
            <ul>
              {Array.isArray(value) ? (
                value.map((v, i) => <li key={i}>{v}</li>)
              ) : (
                <li>{value}</li>
              )}
            </ul>
          </div>
        ))}
      </div>
    ));
  };

  return (
    <div className={style.goalDetails}>
      <h1>User Goals</h1>
      {loading && <p>Loading...</p>}
      {error && <p className={style.error}>{error}</p>}
      {goals && (
        <div className={style.goalContainer}>
          <div className={style.box}>
            <h3>Your Goals & Objectives</h3>
            {renderNestedArray(goals.learning_objective)}
          </div>
          <div className={style.box}>
            <h3>Your Career or Application-Oriented Goals</h3>
            {renderNestedArray(goals.learning_objective_goal)}
          </div>
          <div className={style.box}>
            <h3>Your Background</h3>
            {renderNestedArray(goals.user_status)}
          </div>

          <div className={style.box}>
            <h3>Your Preferences</h3>
            {renderNestedArray(goals.learning_preference)}
          </div>
          <div className={style.box}>
            <h3>Your Constraints </h3>
            {renderNestedArray(goals.learning_constraints)}
          </div>
        </div>
      )}
    </div>
  );
}

export default GoalDetails;
